import { Grid, TextField } from "@mui/material";
import Field from "components/Field";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { SkuDeliveryMethodSettingProps } from "../SkuDeliveryMethodSetting";

interface IframeSettingProps {
  item: SkuDeliveryMethodSettingProps;
}

const IframeSetting = ({ item }: IframeSettingProps) => {
  const { formatMessage: t } = useIntl();
  const validateIframe = useCallback(
    (value: string) => {
      const iframeRegex = /<iframe.*?>.*?<\/iframe>/i;
      if (!value || value.trim() === "") return t({ id: "iframeRequired" });
      if (!iframeRegex.test(value.trim())) return t({ id: "invalidIframe" });
      return undefined;
    },
    [t]
  );

  return (
    <Field
      name={`settingValues[${item.fieldIndex}].value`}
      customValidator={validateIframe}
      required
    >
      {({ input, meta }) => (
        <Grid item xs={12}>
          <TextField
            label={item.name}
            variant="standard"
            fullWidth
            multiline
            rows={4}
            required
            error={meta.error && meta.submitFailed}
            helperText={meta.error && meta.submitFailed && meta.error}
            {...input}
            value={input.value?.trim() || ""}
          />
        </Grid>
      )}
    </Field>
  );
};

export default IframeSetting;